/** Botões outline secundários (Cancelar, formulários inline, etc.). */
export const BTN_OUTLINE_ACTION =
  "inline-flex h-10 shrink-0 items-center justify-center gap-1 rounded-md border border-gray-300 bg-white px-3 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 sm:gap-2 sm:px-4";

/** Aparência dos botões de ação principal das páginas (cor primária, sem borda/sombra). */
export const BTN_PAGE_PRIMARY_APPEARANCE =
  "!border-0 bg-client-primary !text-white !shadow-none hover:!bg-client-primary hover:!text-white hover:brightness-95 focus-visible:!outline-none [&_svg]:!text-white";

/** Toolbar padrão (Adicionar Produto, Adicionar Insumo, Novo usuário). */
export const BTN_PAGE_PRIMARY_ACTION =
  `inline-flex h-10 shrink-0 items-center justify-center gap-1 rounded-md px-3 text-sm font-medium sm:gap-2 sm:px-4 ${BTN_PAGE_PRIMARY_APPEARANCE}`;

/** Financeiro e Fornecedor (gap-2, px-4 py-2). */
export const BTN_PAGE_PRIMARY_ACTION_ROW =
  `inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium ${BTN_PAGE_PRIMARY_APPEARANCE}`;

/** Marketing (padding responsivo). */
export const BTN_PAGE_PRIMARY_ACTION_MARKETING =
  `inline-flex shrink-0 items-center gap-1 rounded-md px-2 py-2 text-sm font-medium sm:gap-2 sm:px-4 ${BTN_PAGE_PRIMARY_APPEARANCE}`;
